import React from 'react'
import { Box, Typography } from '@mui/material'
import colors from '../theme/colors'
import { useTranslation } from "react-i18next"
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { PercentageBarLabel } from '../components/commons/PercentageBarLabel';

export const EjesCardUI = ({ eje, goToTema }) => {

    const { t } = useTranslation()

    return (
        <Card className='card' onClick={() => { goToTema(eje.id_eje) }}
            sx={{
                backgroundColor: eje.disable && colors.textMain,
                pointerEvents: eje.disable && "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: eje.porcentaje > 0 ? "space-around" : "center",
                minHeight: "280px",
                '&:hover': {
                    cursor: 'pointer'
                },
                filter: eje.disable && "grayscale(1)"
            }} >
            <CardContent>
                <Box component={'img'} flex={1} src={require("../images/" + eje.key + ".png")} loading='lazy' alt={eje.key} />
                <Typography variant="h5" component="div" style={{ fontSize: '1.1em' }}>
                    {eje.texto}
                </Typography>
            </CardContent>
            <Box marginBottom={"1em"} marginX={"1em"}>
                {eje.porcentaje > 0 && (
                    <PercentageBarLabel altura={10} percentage={eje.porcentaje} />
                )}
            </Box>
        </Card>
    )
}
